import { render, staticRenderFns } from "./HomeFull.vue?vue&type=template&id=2dcf1c65&scoped=true&"
import script from "./HomeFull.vue?vue&type=script&lang=js&"
export * from "./HomeFull.vue?vue&type=script&lang=js&"
import style0 from "./HomeFull.vue?vue&type=style&index=0&id=2dcf1c65&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2dcf1c65",
  null
  
)

export default component.exports